import { Col, message, Row, Select, Space, Tag } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    ButtonItem,
    Form,
    ModalItem,
    FormItem,
    InputItem,
    ErrorItem,
    HeaderItem,
    BoxItem,
    SelectItem,
    DatePickerItem,
    TextAreaItem,
    TableItem,
    SelectInsumosItem,
    SwitchItem,
} from "../../../../Components/Items";
import moment from "moment";
import axios from "axios";
import SelectEmpleadosItem from "../../../../Components/SelectEmpleadosItem";

const { Option } = Select;

class AgregarAgrupacion extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        archivos: [],
        imagenes: [],
        previewImage: '',
        previewVisible: false,
        previewTitle: '',
        previewImageArchivo: '',
        previewVisibleArchivo: false,
        previewTitleArchivo: '',
        todasInsumosVenta: [],
        objetoInsumosVenta: null,
        modalVerEtiqueta: false,
        piezasLote: [],
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.consultarInformacionLote();
            this.setState({
                piezasSeleccionadas: [],
            })
        }

    }

    consultarInformacionLote() {
        this.setState({ loading: true });
        axios.post("agrupaciones/datosParaAgregarAgrupacion", {
            loteId: this.props.loteId,
            empresaId: this.props.empresaId,
        }, {
            headers: this.props.headersToken,
        }).then((res) => {
            if (res.data.success === 2) {
                this.setState({
                    loading: false,
                    todasInsumosVenta: res.data.insumosVenta,
                    objetoInsumosVenta: res.data.insumosVenta.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.stringBuscar}
                            </Option>
                        );
                    }),
                    piezasLote: res?.data?.lote?.piezas || [],
                });
            } else {
                message.error("Error al consultar la información del lote");
            }
        })
    }

    cerrarAgregarAgrupacion(agregado, agrupacionAgregada) {
        this.formRef.current.resetFields();
        this.props.cerrarAgregarAgrupacion(agregado, agrupacionAgregada);
    }

    onFinish(values) {
        if (!this.state.piezasSeleccionadas || this.state.piezasSeleccionadas.length === 0) {
            message.error("Debe seleccionar al menos una pieza para agregar la agrupación");
            return;
        }
        this.setState({ loading: true });
        axios.post("agrupaciones/agregarAgrupacion", {
            loteId: this.props.loteId,
            empresaId: this.props.empresaId,
            piezasSeleccionadas: this.state.piezasSeleccionadas,
            ...values
        }, {
            headers: this.props.headersToken,
        }).then((res) => {
            this.setState({ loading: false });
            if (res.data.success === 2) {
                message.success("Agrupación agregada correctamente");
                this.cerrarAgregarAgrupacion(true, res.data.agrupacion);
            } else {
                message.error("Error al agregar la agrupación");
            }
        })
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    onSelectChange = (piezasSeleccionadas) => {
        let nuevasPiezasSeleccionadas = [];
        for (const valuePiezaId of piezasSeleccionadas) {
            const pieza = this.state.piezasLote.find(p => p._id.toString() === valuePiezaId.toString());
            if (!pieza.agrupacionLoteId || pieza.estado === 0) {
                nuevasPiezasSeleccionadas.push(valuePiezaId);
            }
        }

        this.setState({ piezasSeleccionadas: nuevasPiezasSeleccionadas });
        if (nuevasPiezasSeleccionadas.length === 1) {
            message.success(`Se ha seleccionado ${nuevasPiezasSeleccionadas.length} pieza`)
        } else if (nuevasPiezasSeleccionadas.length > 1) {
            message.success(`Se han seleccionado ${nuevasPiezasSeleccionadas.length} piezas`)
        }
    }

    render() {
        return (
            <>
                <ModalItem
                    title={"Agregar Agrupación"}
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={() => this.cerrarAgregarAgrupacion()}
                    paddingTop
                    width={1000}
                >
                    <Form
                        ref={this.formRef}
                        name="agregarAgrupacion"
                        layout
                        bottom={
                            <div style={{ display: "flex", justifyContent: "right" }}>
                                <Space style={{ maxWidth: '100%', display: "flex", justifyContent: "right" }} wrap>
                                    <ButtonItem
                                        type="primary"
                                        onClick={() => this.cerrarAgregarAgrupacion()}
                                        rojo
                                        style={{ display: "block", margin: "0 0 0 auto" }}
                                    >
                                        Cerrar
                                    </ButtonItem>
                                    <ButtonItem
                                        type="primary"
                                        htmlType="submit"
                                        style={{ display: "block", margin: "0 0 0 auto" }}
                                    >
                                        Agregar
                                    </ButtonItem>
                                </Space>
                            </div>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        {!this.props.noMostrarDatos && (
                            <Row >
                                <Col span={12}>
                                    {this.props.taxidermia && (
                                        <>
                                            <FormItem
                                                label="Empleados"
                                                name={"empleados"}
                                                fieldKey={"empleados"}
                                                margin
                                            >
                                                <SelectEmpleadosItem
                                                    empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                                    headersToken={this.props.headersToken}
                                                    sinBorde
                                                    autoFocus
                                                    dropdownMatchSelectWidth={600}
                                                    width="100%"
                                                    mode="multiple"
                                                    placeholder="Empleados"
                                                />
                                            </FormItem>
                                        </>
                                    )}
                                    <FormItem
                                        label="Venta"
                                        name="formaVentaId"
                                        fieldKey="formaVentaId"
                                        margin
                                    >
                                        <SelectItem
                                            placeholder="Seleccionar Venta"
                                        >
                                            {this.state.objetoInsumosVenta}
                                        </SelectItem>
                                    </FormItem>
                                    <FormItem
                                        label="Fecha Entrega"
                                        name={"fechaEntrega"}
                                        fieldKey={"fechaEntrega"}
                                        margin
                                    >
                                        <DatePickerItem
                                            placeholder="Fecha Entrega"
                                            style={{ width: '100%' }}
                                            format="DD/MM/YYYY"
                                            disabledDate={(current) => current && current < moment().startOf('day')}
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    {this.props.taxidermia && (
                                        <>
                                            <FormItem
                                                label="Posición"
                                                name={"posicion"}
                                                fieldKey={"posicion"}
                                                margin
                                            >
                                                <InputItem placeholder="Ej. Derecha" />
                                            </FormItem>
                                            <FormItem
                                                label="Talla"
                                                name={"tallaPiel"}
                                                fieldKey={"tallaPiel"}
                                                margin
                                            >
                                                <InputItem placeholder="Talla" />
                                            </FormItem>
                                            <FormItem
                                                label="Forma"
                                                name={"formaId"}
                                                fieldKey={"formaId"}
                                                margin
                                            >
                                                <SelectInsumosItem
                                                    empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                                    headersToken={this.props.headersToken}
                                                    autoFocus
                                                    dropdownMatchSelectWidth={600}
                                                    placeholder="Forma"
                                                    tiposInsumos="activos"
                                                />
                                            </FormItem>
                                            <FormItem
                                                label="H. extra"
                                                name="horarioExtra"
                                                fieldKey={"horarioExtra"}
                                                margin
                                            >
                                                <SwitchItem />
                                            </FormItem>
                                        </>
                                    )}
                                </Col>
                            </Row>
                        )}
                        <HeaderItem>OBSERVACIONES</HeaderItem>
                        <BoxItem>
                            <Row>
                                <Col span={24}>
                                    <FormItem
                                        label="Observaciones"
                                        name={"observaciones"}
                                        fieldKey={"observaciones"}
                                        margin
                                        labelCol={{ span: 4 }}
                                        wrapperCol={{ span: 20 }}
                                    >
                                        <TextAreaItem
                                            placeholder="Observaciones"
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                        </BoxItem>
                        <HeaderItem>PIEZAS</HeaderItem>
                        <BoxItem>
                            <Row>
                                <Col span={24}>
                                    <TableItem
                                        loading={this.state.loading}
                                        size="small"
                                        dataSource={this.state.piezasLote}
                                        rowSelection={{
                                            selectedRowKeys: this.state.piezasSeleccionadas,
                                            onChange: this.onSelectChange.bind(this),
                                            getCheckboxProps: (record) => ({
                                                disabled: (!!record.agrupacionLoteId || record.estado === 0), // desactiva si tiene agrupación
                                                title: (record.agrupacionLoteId || record.estado === 0) ? "Ya está agrupado" : "",
                                            }),
                                        }}
                                        columns={[
                                            {
                                                title: "Descripción",
                                                dataIndex: "descripcion",
                                                key: "descripcion",
                                                width: "40%",
                                                render: (text, record) => (
                                                    <span>
                                                        {record.descripcion}
                                                    </span>
                                                ),
                                            },
                                            {
                                                title: "Cantidad",
                                                dataIndex: "cantidad",
                                                key: "cantidad",
                                                width: "20%",
                                            },
                                            {
                                                title: "Estado",
                                                dataIndex: "agrupacionLoteId",
                                                key: "agrupacionLoteId",
                                                render: (agrupacionLoteId, record) => {
                                                    if (agrupacionLoteId || record.estado === 0) {
                                                        return <Tag color="red">Agrupado</Tag>;
                                                    } else {
                                                        return <Tag color="green">Disponible</Tag>;
                                                    }
                                                },
                                                width: "30%",
                                            },
                                        ]}
                                        pagination={false}
                                    />
                                </Col>
                            </Row>
                        </BoxItem>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        taxidermia: state.empresa.taxidermia,
    };
};

export default connect(mapStateToProps)(AgregarAgrupacion);
